export { FooterPartnerships } from './FooterPartnerships';
